export const SET_DEEPLINK = 'SET_DEEPLINK';
export const SET_IS_DEEPLINKING = 'SET_IS_DEEPLINKING';
export const SET_IS_DEEPLINK = 'SET_IS_DEEPLINK';
export const SET_DEEPLINK_NAVIGATION = 'SET_DEEPLINK_NAVIGATION';
export const SET_DEEPLINK_KIND = 'SET_DEEPLINK_KIND';
export const SET_VERIFIED_VEHICLE = 'SET_VERIFIED_VEHICLE';
export const SET_INCOMPLETE_VEHICLE = 'SET_INCOMPLETE_VEHICLE';
export const SET_APPT_REVISIT = 'SET_APPT_REVISIT';
export const SET_HAS_SERVICES = 'SET_HAS_SERVICES';
export const SET_HAS_TRANSPORTATION_OPTIONS = 'SET_HAS_TRANSPORTATION_OPTIONS';



// WEBPACK FOOTER //
// ./src/store/reducers/deeplink/actionTypes.js